<template>
  <div>
    <ed-movimento-config :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdMovimentoConfig from "@/components/movimento/configuracao/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdMovimentoConfig },
  mounted() {
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>